export interface DeploymentMetadata {
  version: string
  build: string
}

export type VersionFetcher = (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>

function isDeploymentMetadata(value: unknown): value is DeploymentMetadata {
  if (typeof value !== 'object' || value === null) return false

  const metadata = value as Record<string, unknown>
  return typeof metadata.version === 'string' && typeof metadata.build === 'string'
}

export async function fetchDeploymentVersion(fetcher: VersionFetcher = fetch): Promise<string> {
  const response = await fetcher('/version.json', { cache: 'no-store' })

  if (!response.ok) {
    throw new Error(`Version metadata request failed with status ${response.status}`)
  }

  const metadata: unknown = await response.json()

  if (!isDeploymentMetadata(metadata)) {
    throw new Error('Version metadata has an invalid shape')
  }

  return metadata.version
}
